export default __webpack_public_path__ + "static/media/codewars.a52c98cf.webp";